// One fetch wrapper so EVERY API call sends the HttpOnly session cookie. Required in prod
// when the frontend (web) and API run as separate Cloud Run services (different origins) —
// a bare fetch() drops the cookie cross-site and every data call 401s. Harmless when
// served same-origin behind one LB. All API calls must go through this.
export function apiFetch(input: string, init?: RequestInit): Promise<Response> {
  return fetch(input, { ...init, credentials: 'include' })
}
